import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresPerson?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiresPerson = false 
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Always show loading during initial auth check
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  // Only redirect after loading is complete and user is definitely not authenticated
  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // requiresPerson is no longer used since person selection is handled locally in pages

  return <>{children}</>;
};

export default ProtectedRoute;